<template>
  <div>
    <el-form ref="DetailForm" :model="DetailForm" label-width="140px" style="margin-top:10px;margin-bottom:60px;">
        <el-row type="flex" class="row-bg">
          <el-col :span="8">
                <el-form-item label="名称">
                <el-input v-model="DetailForm.t_name" readonly></el-input>
                </el-form-item>
          </el-col>
          <el-col :span="9">
                <el-form-item label="类型">
                <!-- <el-input v-model="DetailForm.t_type" disabled></el-input> -->
                <el-radio disabled v-model="DetailForm.t_type" label="0">普通专题</el-radio>
                <el-radio disabled v-model="DetailForm.t_type" label="1">场馆</el-radio>
                <el-radio disabled v-model="DetailForm.t_type" label="2">古村落</el-radio>
                </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="8">
                <el-form-item label="排序值">
                <el-input v-model="DetailForm.t_sort" readonly></el-input>
                </el-form-item>
          </el-col>
          <el-col :span="8">
                <el-form-item label="代码">
                <el-input v-model="DetailForm.t_code" readonly></el-input>
                </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="8">
                <el-form-item label="发布">
                    <el-radio disabled v-model="DetailForm.t_status" label="0">未发布</el-radio>
                    <el-radio disabled v-model="DetailForm.t_status" label="1">已发布</el-radio>
                </el-form-item>
          </el-col> -->
          <el-col :span="8">
                <el-form-item label="专题负责人">
                    <el-select v-model="DetailForm.t_director" multiple placeholder="请选择" disabled style="width:100%;">
                      <el-option
                          v-for="item in selectAdminOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                </el-form-item>
           </el-col>
          <el-col :span="8">
                <el-form-item label="链接">
                    <el-input v-model="DetailForm.t_url" readonly></el-input>
                </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" class="row-bg">
           <el-col :span="8">
                <el-form-item label="专题负责人">
                    <el-select v-model="DetailForm.t_director" multiple placeholder="请选择" disabled>
                    <el-option
                        v-for="item in selectAdminOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                    </el-select>
                </el-form-item>
           </el-col>
        </el-row> -->
        <el-row type="flex" class="row-bg">
            <el-col :span="8">
                    <el-form-item label="专题首页PC端">
                        <el-input v-model="DetailForm.t_indexpage_pc" readonly></el-input>
                    </el-form-item>
            </el-col>
             <el-col :span="8">
                    <el-form-item label="专题首页移动端">
                        <el-input v-model="DetailForm.t_indexpage_m" readonly></el-input>
                    </el-form-item>
             </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="16">
                <el-form-item label="搜索关键字设置" prop="t_keywords">
                    <el-input v-model="DetailForm.t_keywords" readonly></el-input>
                </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="16">
                <el-form-item label="描述">
                    <el-input type="textarea" :rows="4" v-model="DetailForm.t_desc" readonly></el-input>
                </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="16">
                <!-- <el-form-item label="封面图">
                    <img :src="DetailForm.t_cover" width="150px">
                </el-form-item> -->
            <el-form-item label="封面图" prop="t_cover">
                <el-upload
                    disabled
                    :class="{disabled:uploadDisabled}"
                    :limit="1"
                    :action="uploadAddress"
                    list-type="picture-card"
                    :on-preview="handleDetailPreview"
                    :file-list="DetailUploadFileList">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="DetailPreviewDialogVisible">
                    <img width="100%" :src="DetailPreviewDialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'componentspage1',
  data() {
      return {
          DetailForm : {
              t_sort: '',
              t_status: '',
              t_name: '',
              t_code : '',
              t_type : '',
              t_id : '',
              t_cover : '',
              t_desc : '',
              t_url : '',
              t_indexpage_pc : '',
              t_indexpage_m : '',
              t_director : '',
              t_keywords: ''
          },
          selectAdminOptions : [],
          uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址
          DetailUploadFileList : [],
          DetailPreviewDialogVisible : false,
          DetailPreviewDialogImageUrl : '',
          uploadDisabled : true
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      // 获取负责人
      getSelectAdmin() {
        this.$http.get(`${api.dev}/p/main/drop/selectAdmin`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200) {
            this.selectAdminOptions = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message: res.body.msg,
              type: 'error'
            });
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'})
            },2000)
          }
        })
      },
      getInfo() {
          this.$http.get(`${api.dev}/p/main/topic/select`,{params: {access_token: getToken(),t_id : this.$route.params.id}}).then(res => {
                if(res.body.code == 200) {
                    // 关闭加载器
                    // loading.close();
                    // this.DetailDialogTableVisible = true;

                    this.DetailForm.t_sort = res.body.content.t_sort;
                    // this.DetailForm.t_status = (res.body.content.t_status).toString(); // Radio必须为字符串类型
                    this.DetailForm.t_name = res.body.content.t_name;
                    this.DetailForm.t_code = res.body.content.t_code;
                    this.DetailForm.t_type = (res.body.content.t_type).toString(); // Radio必须为字符串类型
                    this.DetailForm.t_id = res.body.content.t_id;
                    this.DetailForm.t_cover = `${api.dev}${res.body.content.t_cover}`;
                    this.DetailForm.t_desc = res.body.content.t_desc;
                    this.DetailForm.t_url = res.body.content.t_url;
                    this.DetailForm.t_indexpage_pc = res.body.content.t_indexpage_pc;
                    this.DetailForm.t_indexpage_m = res.body.content.t_indexpage_m;
                    this.DetailForm.t_director = res.body.content.t_director;
                    this.DetailForm.t_keywords = res.body.content.t_keywords;

                    this.DetailUploadFileList = [{url: `${api.address}${res.body.content.t_cover}`}];
                }else if(res.body.code == 500) {
                    this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
                    removeToken();
                    setTimeout(function () {
                        this.$router.push({path: '/login'})
                    },2000)
                }
            })
      },
      // 放大图片
    handleDetailPreview(file) {
        this.DetailPreviewDialogVisible = true;
        this.DetailPreviewDialogImageUrl = file.url;
    },
  },
  created() {
      this.getInfo();
      this.getSelectAdmin();
  }
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
    margin-right -15px
.el-form-item
    margin-bottom 30px
    
form.el-form 
    width 1180px;
</style>
